import React, {useState} from 'react';
import Title from '../../Components/Formatting/Customer/Title';
import Services from '../../Components/Formatting/Services';
import Reorder, {Draggable} from '../../Components/Containers/Reorder';
import Page from '../../Components/Containers/Page';
import { classNames } from '../../Services/helpers';
import Subtitle from '../../Components/Formatting/Customer/Subtitle';
import ButtonRow from '../../Components/Button/ButtonRow';
import Button from '../../Components/Button/Button';

const Reordering = ({jobs, setIsReordering, reorder: saveNewOrder}) => {
    const [orderedJobs, setOrderedJob] = useState(jobs.sort((a, b) => a.roundPosition - b.roundPosition));
    const [saving, setSaving] = useState(false);

    const reorder = (startIndex, endIndex) => {
        setOrderedJob(jobs => {
            const reordered = Array.from(jobs);
            const [removed] = reordered.splice(startIndex, 1);
            reordered.splice(endIndex, 0, removed);

            return reordered
        });
    }

    const saveOrder = async () => {
        setSaving(true);
        await saveNewOrder({jobIds: orderedJobs.map(job => job.id)});
        setIsReordering(false);
    }

    return <Page>
        <ul className="mr-14">
            <ButtonRow className="text-center">
                <Button theme="primary" onClick={() => saveOrder()} disabled={saving} loading={saving} label="Save" />
                <Button theme="secondary" onClick={() => setIsReordering(false)} disabled={saving} label="Cancel" />
            </ButtonRow>

            <Reorder reorder={reorder}>
                {orderedJobs.map((job, index) => <Job key={job.id} job={job} index={index} />)}
            </Reorder>
        </ul>
    </Page>

}

const Job = ({job, index}) => {
    return <Draggable draggableId={job.id} index={index}>
        {(provided, snapshot) => <li ref={provided.innerRef}
            className={classNames(
                'mb-3 p-3 rounded-lg border border-2 bg-white',
                snapshot.isDragging && 'border-solid rotate-3 shadow-lg',
                !snapshot.isDragging && 'border-dashed',
            )}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
        >
            <div className="grow">
                <p className="font-bold"><Title customer={job.customer} /></p>
                <p><Subtitle customer={job.customer} /></p>
                <p className="mt-1 text-muted">{job.title ?? <Services services={job.services} />}</p>
            </div>
        </li>}
    </Draggable>
}

export default Reordering;